
// Production configuration management - Updated to use new environment system
import { config, getEnvironmentConfig, isProductionEnvironment, isDevelopmentEnvironment } from '@/config/environment';

export interface AppConfig {
  supabase: {
    url: string;
    anonKey: string;
  };
  mercadoPago: {
    publicKey: string;
    accessToken?: string;
  };
  monitoring: {
    enabled: boolean;
    logLevel: 'debug' | 'info' | 'warn' | 'error';
  };
  features: {
    notifications: boolean;
    realTimeMetrics: boolean;
    paymentIntegration: boolean;
  };
  performance: {
    apiTimeout: number;
    retryAttempts: number;
    cacheTimeout: number;
  };
  app: {
    siteUrl: string;
    domain: string;
    name: string;
  };
}

// Export the configuration from the new environment system
export const appConfig: AppConfig = {
  supabase: config.supabase,
  mercadoPago: config.mercadoPago,
  app: config.app,
  monitoring: {
    enabled: isProductionEnvironment(),
    logLevel: isProductionEnvironment() ? 'warn' : 'debug'
  },
  features: {
    notifications: true,
    realTimeMetrics: isProductionEnvironment(),
    paymentIntegration: true
  },
  performance: {
    apiTimeout: config.api.timeout,
    retryAttempts: config.api.retryAttempts,
    cacheTimeout: isProductionEnvironment() ? 5 * 60 * 1000 : 1000 // 5 min in prod, 1s in dev
  }
};

// Re-export helpers for backwards compatibility
export { 
  config,
  isProductionEnvironment as isProduction, 
  isDevelopmentEnvironment as isDevelopment,
  getBaseUrl,
  getDomain,
  getCanonicalUrl,
  getMercadoPagoPublicKey
} from '@/config/environment';

// Feature flags
export const isFeatureEnabled = (feature: keyof AppConfig['features']): boolean => {
  return appConfig.features[feature];
};

// Validate configuration on module load
console.log('📋 Configuração da aplicação carregada:', {
  environment: config.app.environment,
  domain: config.app.domain,
  mercadoPagoConfigured: !config.mercadoPago.publicKey.includes('YOUR_')
});
